// material-ui
import { alpha, createTheme } from '@mui/material/styles';

// third-party
import { presetDarkPalettes, presetPalettes } from '@ant-design/colors';

// project import
import ThemeOption from './theme';
import { ThemeMode } from 'config';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode, presetColor) => {
  const colors = mode === ThemeMode.DARK ? presetDarkPalettes : presetPalettes;

  let greyPrimary = [
    '#ffffff',
    '#F7F9FB',
    '#F3F4F6',
    '#E2E8F0',
    '#CBD5E1',
    '#94A3B8',
    '#64748B',
    '#475569',
    '#334155',
    '#1E293B',
    '#000000'
  ];
  let greyAscent = ['#F7F9FB', '#94A3B8', '#334155', '#0F172A'];
  let greyConstant = ['#F7F9FB', '#F1F5F8'];

  if (mode === ThemeMode.DARK) {
    greyPrimary = ['#000000', '#1E293B', '#334155', '#475569', '#64748B', '#94A3B8', '#CBD5E1', '#E2E8F0', '#F3F4F6', '#F7F9FB', '#ffffff'];
    // greyPrimary.reverse();
    greyAscent = ['#F7F9FB', '#94A3B8', '#334155', '#0F172A'];
    greyConstant = ['#0F172A', '#CBD5E1'];
  }
  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      text: {
        primary: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.87) : paletteColor.grey[700],
        secondary: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.45) : paletteColor.grey[500],
        disabled: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.1) : paletteColor.grey[400]
      },
      action: {
        disabled: paletteColor.grey[300]
      },
      divider: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.05) : paletteColor.grey[200],
      background: {
        paper: mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0],
        default: paletteColor.grey.A50
      },
      button: {
        main: paletteColor.primary.main
      },
      selectbackGround: {
        main: '#f5f5f5'
      },
      defaultWhite: {
        main: '#ffffff'
      },
      greyInput: {
        color: '#475569',
        background: `linear-gradient(0deg, ${paletteColor.grey[200]}, ${paletteColor.grey[200]}), linear-gradient(0deg, ${paletteColor.grey.A800}, ${paletteColor.grey.A800})`,
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none'
        }
      },
      paperInput: {
        color: mode === ThemeMode.DARK ? alpha(paletteColor.grey[900], 0.87) : paletteColor.grey[700],
        background: mode === ThemeMode.DARK ? paletteColor.grey[100] : paletteColor.grey[0]
      }
    }
  });
};

export default Palette;
